import React, { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { Tag } from "rsuite"

import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import "./scss/report.scss"
import { Table, Spin, Tooltip } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../utils/storage.service";

const ReportLtOnline = () => {
    const [title, setTitle] = useState("")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0]?.id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [chart, setChart] = useState([])
    const [table, setTable] = useState([])
    const [keyword, setKeyword] = useState([])
    const [totalBooking, setTotalBooking] = useState(0)
    const [totalComBooking, setTotalComBooking] = useState(0)
    const [totalWelcome, setTotalWelcome] = useState(0)
    const [totalRoseWelcome, setTotalRoseWelcome] = useState(0)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    useEffect(() => {
        setTitle("Báo cáo lễ tân")
    }, [])
    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }
    const fetchData = async (sD, eD, s) => {
        const { users, data } = await async.parallel({
            users: (cb) => {
                axiosService(`api/reports/store/users/${store}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            },
            data: (cb) => {
                axiosService(`api/mysql/report-offline-lt/all?start=${sD}&end=${eD}&store=${store}&keyword=${keyword}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const {totalBooking, totalComBooking, totalWelcome, totalRoseWelcome, dataChart, dataTable } = data.data
            // setChart(dataChart)
            setTotalBooking(totalBooking)
            setTotalComBooking(totalComBooking)
            setTotalWelcome(totalWelcome)
            setTotalRoseWelcome(totalRoseWelcome)
            setTable(dataTable)
        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store, keyword])

    const config = {
        data: chart,
        isStack: true,
        xField: 'value',
        yField: 'name',
        seriesField: 'type',
        label: false,
        xAxis: {
            label: {
                formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
        },
        tooltip: {
            formatter: (data) => {
                return {
                    name: data.name,
                    value: convertCurrency(data.value)
                };
            },
        }
    };
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    const columns = [
        {
            title: 'Nhân viên',
            dataIndex: 'user_name',
            render: (data) => {
                return (
                    <>
                        <p>{data}</p>
                    </>
                )
            },
            sorter: (a, b) => a.countOrder.length - b.countOrder.length,
        },
        {
            title: 'Tổng số lượng lịch xác nhận',
            dataIndex: 'countBooking',
            align: "center",
            sorter: {
                compare: (a, b) => a.countBooking - b.countBooking,
                multiple: 3,
            },
        },
        {
            title: 'Tổng hoa hồng xác nhận lịch',
            dataIndex: 'rose_confirm',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Tổng số lượng khách',
            dataIndex: 'countCustomer',
            align: "center",
            sorter: {
                compare: (a, b) => a.countCustomer - b.countCustomer,
                multiple: 3,
            },
        },
        {
            title: 'Tổng hoa hồng đón tiếp',
            dataIndex: 'rose_welcome',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        }
    ];
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    return (
        <div className={`container-fluid ${styles.background}`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                title={title} type={"sales"}
                csvData={table} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                header={
                    [
                        { label: 'Nhân viên', key: "user_name" },
                        { label: "Số lịch đã xác nhận", key: "countBooking" },
                        { label: "Hoa hồng xác nhận lịch", key: "rose_confirm" },
                        { label: "Số khách đón tiếp", key: `countCustomer` },
                        { label: "Hoa hồng đón tiếp", key: `rose_welcome` },
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row>
                    <Col xs={12} md={8}>
                        <Row className="h-100">
                            <Col xs={12} md={6}>
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <span className={styles.textTag3}>Tổng tiền hoa hồng lễ tân: </span>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <span className={styles.textTag}> </span>
                                            <br />
                                            <span className={styles.textTag4}>Tổng số lượng lịch xác nhận: <Tooltip title='Tổng số lượng lịch đặt của khách hàng đã được xác nhận và đã hoàn thành thực tế (khách hàng đã đến và sử dụng thành công dịch vụ theo lịch đã đặt).'>
                                                <i className="fas fa-info-circle"></i>
                                                    </Tooltip>
                                            </span>
                                            <span className={styles.textTag4}>Tổng hoa hồng xác nhận lịch: <Tooltip title='Tổng số tiền hoa hồng mà nhân sự được nhận dựa trên số lượng lịch hẹn khách đã được xác nhận và thực tế sử dụng dịch vụ thành công tại cơ sở.'>
                                                <i className="fas fa-info-circle"></i>
                                                    </Tooltip>
                                            </span>
                                            <span className={styles.textTag4}>Tổng số lượng khách đón tiếp: <Tooltip title='Tổng số khách hàng thực tế đã đến và hoàn thành ít nhất một dịch vụ trong ngày, được tính theo đầu người, không tính trùng theo số lượng lịch đặt hoặc số lượng dịch vụ.'>
                                                <i className="fas fa-info-circle"></i>
                                                    </Tooltip></span>
                                            <span className={styles.textTag4}>Tổng hoa hồng đón tiếp: <Tooltip title='Tổng số tiền hoa hồng nhân sự được nhận, tính dựa trên số lượng khách hàng thực tế đã đến và hoàn thành ít nhất một dịch vụ trong ngày, không phân biệt số lượng lịch đặt hay số dịch vụ.'>
                                                <i className="fas fa-info-circle"></i>
                                                    </Tooltip></span>
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag}>
                                                {convertCurrency(totalComBooking + totalRoseWelcome)}</span>
                                            <span className={styles.textTag2}> {totalBooking}</span>
                                            <span className={styles.textTag2}> {convertCurrency(totalComBooking)}</span>
                                            <span className={styles.textTag2}> {totalWelcome}</span>
                                            <span className={styles.textTag2}> {convertCurrency(totalRoseWelcome)}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>

                        </Row>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col xs={12}>
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <div className="border-bottom w-100 mb-2">
                                Bảng số liệu chi tiết
                            </div>
                            <Table 
                                columns={columns} 
                                dataSource={table}
                                pagination={{ pageSize: 10 }}
                                showSorterTooltip={{ title: '' }}
                                scroll={{ x: 1300 }}
                                bordered
                            />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}
export default ReportLtOnline